var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSerbia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7278)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 512C397.385 512 512 397.385 512 256C512 114.615 397.385 0 256 0C114.615 0 0 114.615 0 256C0 397.385 114.615 512 256 512Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C114.616 0 0 114.616 0 256C0 287.314 5.633 317.311 15.923 345.043H496.078C506.368 317.311 512 287.314 512 256C512 114.616 397.384 0 256 0Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 0C145.929 0 52.0941 69.472 15.9231 166.957H496.078C459.906 69.472 366.071 0 256 0V0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.198 144.696V272.402C66.198 345.046 161.099 367.305 161.099 367.305C161.099 367.305 255.999 345.046 255.999 272.402V144.696H66.198Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.446 166.957H216.751V122.435L194.49 133.565L161.099 100.174L127.707 133.565L105.446 122.435V166.957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.739 290.183L161.391 217.835L89.043 290.183L112.654 313.794L161.391 265.057L210.128 313.794L233.739 290.183Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.739 222.609H199.983C201.881 219.333 202.985 215.539 202.985 211.481C202.985 199.185 193.018 189.22 180.724 189.22C172.229 189.22 164.852 193.978 161.099 200.973C157.346 193.979 149.969 189.22 141.474 189.22C129.18 189.22 119.213 199.185 119.213 211.481C119.213 215.539 120.317 219.334 122.215 222.609H89.043C89.043 234.904 99.752 244.87 112.045 244.87H111.304C111.304 257.165 121.27 267.131 133.565 267.131C133.565 278.017 141.383 287.061 151.708 288.997L134.168 328.599C142.574 332.016 151.76 333.914 161.392 333.914C171.024 333.914 180.21 332.016 188.616 328.599L171.076 288.997C181.401 287.063 189.219 278.018 189.219 267.131C201.514 267.131 211.48 257.165 211.48 244.87H210.739C223.031 244.87 233.739 234.903 233.739 222.609V222.609Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7278"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSerbia);
export default __webpack_public_path__ + "static/media/serbia.8d24c4310e04364a08a360a8aad0db3a.svg";
export { ForwardRef as ReactComponent };